import React, { useState } from "react";
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { IoChevronDownCircleOutline, IoSettingsOutline } from "react-icons/io5";
import { getSavedLanguage, setLanguage } from "../../helpers/LanguageHelper";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slices/AuthSlice";
const languages = [
  { code: "lg", label: t("txt.logout") },
  { code: "settings", label: t("txt.settings") },
];

const SettingsSwitcher: React.FC = () => {
  const dispatch = useDispatch();

  const handleSelect = (code: string) => {
    switch (code) {
      case "lg":
        dispatch(logout());

        break;
      case "settings":
        break;
    }
  };

  return (
    <Menu>
      <MenuButton>
        <IoSettingsOutline
          style={{ paddingBottom: "3px" }}
          size={24}
          className="icon"
          color="gray"
        />
      </MenuButton>
      <MenuList width={"100px"}>
        {languages.map((l) => (
          <MenuItem key={l.code} onClick={() => handleSelect(l.code)}>
            {l.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default SettingsSwitcher;
